import React, { Component } from "react";
import {
    Form, Select, Button, Input, DatePicker, Row, Col, Spin, Checkbox, Tabs, message, Radio, Space, Image, Upload
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import dayjs from "dayjs";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import VehicleWorkingHoursStore from "../store/VehicleWorkingHoursStore";
import { format, addMinutes } from "date-fns";
import StudentRouteStore from "../store/StudentRouteStore";
import StudentTripStore from "../store/StudentTripStore";
import TabPane from "antd/es/tabs/TabPane";
import { UploadOutlined, CloseOutlined } from "@ant-design/icons";
import Autocomplete from "react-google-autocomplete";
import config from "../config";
import "./AddAccount.css";
import AccountFormFields from "./Plugins/AddAccount/AccountFormFields";
import UserDetailsFields from "./Plugins/AddAccount/UserDetailsFields";
import AccountFormPaymentFields from "./Plugins/AddAccount/AccountFormPaymentFields";
import addIcon from "../assets/images/NewDesign/plus-lg.svg";
import dashIcon from "../assets/images/NewDesign/dash.svg";
import StudentAssignBus from "./StudentAssignBus";
import AssignStudent from "./AssignStudent";
import { area } from "d3";
import { get } from "lodash";
import StudentStore from "../store/StudentStore";
import moment from "moment/moment";


const { Option } = Select;


const dateFormat = "YYYY-MM-DD";


class StudentTripAdd extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            showProjectDetail: false,
            showAddDriver: false,
            startOdometer: "",
            endOdometer: "",
            stId: -1,
            vehiclesAssetArray: [],
            manualDistanceId: -1,
            companyId: "",
            loadData: 0,
            loadingSpin: false,
            showVehicleCombo: false,
            showRouteCombo: false,
            showSchoolTripCombo: false,
            includeStaff: false,
            tripClosure: false,
            showTripCard: false,
            activeTab: "1",
            tabErrors: {},
            formError: false,
            vehicleId: "",
            arealist: [],
        };
        this.vehicleStore = new VehicleStore();
        this.companyStore = new CompanyStore();
        this.workingHoursStore = new VehicleWorkingHoursStore();
        this.studentRouteStore = new StudentRouteStore(this);
        this.studentTripStore = new StudentTripStore();
        this.studentStore = new StudentStore(this);
        this.tripTypeOptions = [
            { label: "Pickup", value: 1 },
            { label: "Dropoff", value: 2 }
        ];
    }

    layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    onTripSubmit = async (values) => {
        this.setState({ loading: true });
        console.log(values);

        const data = {
            ...values,
            routeStartpDate: values.routestartDate
                ?.format("YYYY-MM-DD"),
            routestopDate: values.routestopDate
                ?.format("YYYY-MM-DD"),
            companyId: this.state.companyId,
            stId: this.state.stId,

        };

        const resp = await this.studentTripStore.addData(data);
        console.log(resp.data)
        const tripId = resp?.data?.TripId
        // debugger
        if (resp?.data?.success === "S") {
            message.success(resp.data.message);
            // this.closeModal();
            this.setState({ loading: false, tripId: tripId, assignedVehicleId: values.vehicleId });
            this.handleTabChange("2");
        } else {
            message.error(resp.data.message);
            this.setState({ loading: false, tripId: tripId });

        }
        // await this.props.response(resp);


        // await this.props.response(resp);


    };

    setFieldValue = () => {
        this.formRef.current.setFieldsValue({
            distanceTravel:
                parseFloat(this.state.endOdometer) -
                parseFloat(this.state.startOdometer),
        });
    };
    AreaLoad = async () => {
        const arealist = await this.studentRouteStore.getArea();
        // console.log(arealist, "arealist");
        await this.setState({ arealist: arealist, update: 1 });
    }
    async componentDidMount() {
        if (Number(this.props.getUserData().isadmin) !== -1) {
            this.context.viewStateStore.setStudentTripDetails({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ isadmin: this.props.getUserData().isadmin });
            const data = await this.workingHoursStore.getAssignAsset({
                companyId: this.props.getUserData().userCompanyId,
            });
        }
        this.AreaLoad();

        await this.setState({ loadList: 1 });

        const stId = this.props.stId;

        console.log("id", stId);

        if (stId) {
            this.filldata(stId);
            this.setState({ stId: stId });
        }
    }

    async filldata(stId) {
        // await this.setState({ loadingSpin: true });
        this.timeOptions()
        this.setState({ tripId: stId })
        const getTripDetails =
            await this.studentTripStore.getTripData(stId);
        console.log(getTripDetails, "id");

        await this.setState({ companyId: getTripDetails.companyId, tripType: Number(getTripDetails.tripType), assignedVehicleId: getTripDetails.AssignedVehicleId });
        const singleData = await this.companyStore.getCompanyDataById(
            getTripDetails.companyId
        );
        await this.studentRouteStore.loadData({
            offset: 0,
            limit: 50,
            companyId: getTripDetails.companyId
        });
        this.sortTripBy(getTripDetails.SortStudentBy);
        this.handleTripClosureChange(getTripDetails.isAutomaticTripClosure);
        this.onTripCLosureSelect(getTripDetails.tripClosure)
        this.handleRouteChange(getTripDetails.routeId);

        console.log("single", getTripDetails.endTime);


        await this.workingHoursStore.getAssignAsset({
            companyId: getTripDetails.companyId,
        });

        await this.formRef.current.setFieldsValue({
            companyId: singleData,
            tripName: getTripDetails.tripName,
            tripType: Number(getTripDetails.tripType),
            vehicleId: getTripDetails.AssignedVehicleId,
            area: getTripDetails.area,
            SortStudentBy: getTripDetails.SortStudentBy,
            startTime: getTripDetails.startTime,
            endTime: getTripDetails.endTime,
            routeId: getTripDetails.routeId,
            routestartDate: moment(getTripDetails.routestartDate, "YYYY-MM-DD"),
            routestopDate: moment(getTripDetails.routestopDate, "YYYY-MM-DD"),
            tripClosure: getTripDetails.tripClosure,
            isAutomaticTripClosure: getTripDetails.isAutomaticTripClosure,
            tripCloseBufferTime: getTripDetails.tripCloseBufferTime,
            tripCardNo: getTripDetails.tripCardNo,
            dayofweeks: getTripDetails.dayofweeks
                ? getTripDetails.dayofweeks.split(",")
                : []




        });
        // debugger
        this.getRouteDetails();

        await this.setState({ loadingSpin: false });
        await this.setState({ loadData: 1 });
    }

    handleChange = async (comp) => {
        console.log(comp.value);
        await this.setState({ companyId: comp.value });
        await this.formRef.current.setFieldsValue({
            companyId: this.state.companyId,
        });

        await this.workingHoursStore.getAssignAsset({
            companyId: comp.value,
        });

        const data = {
            offset: 0,
            limit: 50,
            companyId: comp.value
        }
        await this.studentRouteStore.loadData(data);

        await this.studentStore.getSchooltrip(comp.value);


    }

    closeModal = () => {
        this.props.closeModal();
    };
    timeOptions = () => {
        const timeArray = [];

        let startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM

        let endTime = new Date(2000, 0, 1, 23, 30);
        for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
            // const formattedTime = format(time, 'h:mm aa');
            const formattedTime = format(time, "HH:mm");
            var ob = {
                formattedTime: formattedTime,
                time: time,
            };
            timeArray.push(ob);
        }

        return timeArray.map((data) => {
            return (
                <Select.Option key={data.formattedTime} value={data.formattedTime}>
                    {format(data.time, "h:mm aa")}
                </Select.Option>
            );
        });
    };
    sortTripBy = async (val) => {
        this.setState({ SortStudentBy: val });
        this.formRef.current.setFieldsValue({
            totalStudent: 0,
            tripCode: '',
            area: '',
            totalStaff: 0,
        });
        if (val == 'VehicleNo') {
            const data = await this.workingHoursStore.getAssignAsset({
                companyId: this.state.companyId,
            });
            // console.log(data, "aaa")
            this.setState({ loadData: 1 })
            this.setState({ showVehicleCombo: true, showSchoolTripCombo: true, showRouteCombo: false });
            await this.studentStore.getSchooltrip(this.state.companyId);
        } else if (val == 'Area') {
            this.setState({ showRouteCombo: true, showVehicleCombo: false, showSchoolTripCombo: false });
        }
        // else if (val == 'SpecialTrip') {
        //     this.getSpecialVehicles();
        // } else {
        //     this.setState({ showVehicleCombo: false })
        //     this.setState({ showSchoolTripCombo: false })

        // }
    };
    onTripCLosureSelect = (val) => {
        if (val == 'RFID') {
            this.setState({ showTripCard: true });
        } else {
            this.setState({ showTripCard: false });
        }
    };
    handleIncludeStaffChange = (e) => {
        const checked = e.target.checked;

        if (checked) {
            this.setState({ includeStaff: true })
        } else {
            this.setState({ includeStaff: false })

        }
    };

    handleTripClosureChange = (checked) => {
        if (checked) {
            this.setState({ tripClosure: true });
        } else {
            this.setState({ tripClosure: false, showTripCard: false });
        }
    };

    handleRouteChange = async () => {
        const routeId = await this.formRef.current.getFieldValue("routeId");
        const vehicleId = await this.formRef.current.getFieldValue("vehicleId");
        const CompnId = await this.formRef.current.getFieldValue("companyId");
        const SchoolTripId = await this.formRef.current.getFieldValue("SchoolTripId");

        const data = {
            routeId: routeId,
            vehicleId: vehicleId,
            SchoolTripId: SchoolTripId,
            companyId: this.state.companyId,
            tripType: this.getTripTypeLabel()

            // tripType: this.state.TripTypeLabel,
        }

        const getRouteData = await this.studentRouteStore.loadData(data);
        console.log(getRouteData)
        this.formRef.current.setFieldsValue({
            totalStudent: getRouteData.studentCount || 0,
            tripCode: getRouteData.nextstId,
            area: getRouteData.RouteData[0].areaName,
            totalStaff: getRouteData.employeeCount || 0,
        });



    };
    showTabTitle = () => {
        const { activeTab } = this.state;

        if (activeTab === "1") {
            return this.context.translate("_STUDENT_TRIP_DETAILS_");
        } else if (activeTab === "2") {
            return this.context.translate("_ASSIGN_BUS_");
        } else if (activeTab === "3") {
            return this.context.translate("_ASSIGN_STUDENT_");
        }
    };

    showTabDesc = () => {
        const { activeTab } = this.state;
        if (activeTab === "1") {
            return this.context.translate("_TRIP_ADD_DESC_");
        } else if (activeTab === "2") {
            return this.context.translate("_ASSIGN_BUS_DESC_");
        } else if (activeTab === "3") {
            return this.context.translate("_ASSIGN_STUDENT_DESC_");
        }
    };

    handleTabChange = (key) => {
        // debugger
        this.setState({
            activeTab: key,
            formError: false, // Reset formError when switching tabs
        });
    };
    handleNextClick = async () => {
        const form = this.formRef.current;

        if (form) {
            try {
                if (this.state.activeTab === "1") {
                    // Validate only the fields in the 'User Information' tab
                    await form.validateFields([
                        'companyId',
                        'tripName',
                        'SortStudentBy'
                    ]);
                } else {
                    // Validate all fields in other tabs
                    await form.validateFields();
                }

                const { activeTab } = this.state;
                let nextTab = String(Number(activeTab) + 1);
                this.setState({
                    activeTab: "2",
                    formError: false, // Reset formError when switching tabs
                });

            } catch (err) {
                console.error("Form Validation Error:", err);
                message.error(
                    this.context.translate("_FLEET_VEHICLE_VEHICLEDETAIL_ERRORMSG_")
                    // "Please fill correct data in the fields that are marked red."
                );
                this.setState({ formError: true });
            }
        }

    }
    getRouteDetails = async () => {

        const vehicleId = this.formRef.current.getFieldValue("vehicleId");
        await this.setState({ vehicleId: vehicleId.value });
        const data = {
            stId: this.state.stId,
            vehicleId: vehicleId,
            companyId: this.state.companyId,
            tripType: this.getTripTypeLabel()
        }
        // const routeDetails = await this.studentTripStore.loadTripData(data);
        const getRouteData = await this.studentRouteStore.loadData(data);
        console.log(getRouteData)
        this.formRef.current.setFieldsValue({
            totalStudent: getRouteData.studentCount || 0,
            tripCode: getRouteData.nextstId,
            // area: getRouteData.RouteData[0].areaName,
            totalStaff: getRouteData.employeeCount || 0,
        });


    };
    getTripTypeLabel = () => {
        const value = this.formRef.current.getFieldValue("tripType");
        console.log(value)
        return this.tripTypeOptions.find(o => o.value === value)?.label;
    };

    finalSubmit = (response) => {
        console.log("response", response)
        this.props.responseMsg(response)
    }
    handleFormError = (err) => {
        console.log(err);
        const { errorFields } = err;

        const tabErrors = {};

        errorFields.forEach(({ name }) => {
            console.log(name)
            const [fieldName] = name;
            const tabFieldMappings = {
                companyId: 1,
                tripName: 1,
                SortStudentBy: 1,
                tripType: 1
            };
            console.log(tabFieldMappings, fieldName)
            const tab = tabFieldMappings[fieldName];
            console.log(tab);
            if (tab) {
                tabErrors[tab] = true;
            }
        });

        this.setState({ tabErrors }); // Update the state with tabErrors
    };

    async componentDidUpdate() {
        console.log("did update")
        const singleData = await this.companyStore.getCompanyDataById(
            this.state.companyId
        );
        await this.formRef.current.setFieldsValue({
            companyId: singleData
        })
    }
    handleTripTypeChange = (value) => {
        console.log("Selected Trip Type:", value);

        // Reset specific fields
        this.formRef.current?.resetFields([
            "SortStudentBy", "routeId", "vehicleId", "totalStudent", "area"
        ]);


    };
    render() {
        return (
            <div style={{ padding: 0, height: "100%" }}>
                <div style={{ height: "100%" }}>
                    <Spin
                        wrapperClassName="spinClass"
                        spinning={this.state.loadingSpin}
                    >
                        <Form
                            ref={this.formRef}
                            labelCol={{
                                span: 20,
                            }}
                            layout="vertical"
                            name="companyFrm"
                            onFinish={this.onTripSubmit}

                            onFinishFailed={(value) => {
                                console.log(value);
                                this.handleFormError(value);
                            }}
                            className="accountFormClass" //change
                        >
                            <div style={{ height: "100%" }}>
                                <div
                                    style={{
                                        background: "#07163D",
                                        padding: "15px",
                                        height: "10%",
                                    }}
                                >
                                    <h3 className="tab-title">{this.showTabTitle()}</h3>
                                    <p className="tab-description">{this.showTabDesc()}</p>
                                </div>
                                <Tabs
                                    destroyInactiveTabPane
                                    className="accountTabs"
                                    style={{ height: "100%" }}
                                    activeKey={this.state.activeTab}
                                    onChange={this.handleTabChange}
                                >
                                    <TabPane
                                        tab={
                                            <span
                                                className={
                                                    this.state.tabErrors["1"] && "validation-failed"
                                                }
                                            >
                                                <Button
                                                    type="text"
                                                    style={{
                                                        background:
                                                            this.state.activeTab === "1"
                                                                ? " rgba(255, 255, 255, 0.30)"
                                                                : "rgb(7, 22, 61)",
                                                        border: "none",
                                                        borderRadius: "0px",
                                                    }}
                                                >
                                                    {this.context.translate(
                                                        "_TRIP_DETAILS_"
                                                    )}
                                                </Button>
                                            </span>
                                        }
                                        key="1"
                                    >
                                        <Row
                                            style={{
                                                overflowY: "scroll",
                                                height: "90%",
                                                paddingInlineStart: "20px",
                                            }}
                                        >
                                            <Col span={12} className="formColumnClass">
                                                {(this.props.getUserData().isadmin === -1 ||
                                                    this.props.getUserData().isadmin === 3) && (
                                                        <Form.Item
                                                            name="companyId"
                                                            // label="Account"
                                                            className="uploadCompany"
                                                            required={false}
                                                            label={
                                                                <span>
                                                                    {this.context.translate(
                                                                        "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                                                                    )}{" "}
                                                                    <span style={{ color: "red" }}>*</span>
                                                                </span>
                                                            }
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: `${this.context.translate(
                                                                        "_ACCOUNT_"
                                                                    )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                                },
                                                            ]}
                                                        >
                                                            <CompanyAutocomplete
                                                                allowClear={true}
                                                                onChange={this.handleChange}
                                                                style={{ width: "100%" }}
                                                            />
                                                        </Form.Item>
                                                    )}

                                                <Form.Item
                                                    className="uploadCompany"
                                                    name="tripType"
                                                    // initialValue={1}
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_TRIP_TYPE_"
                                                            )}{" "}
                                                            <span style={{ color: "red" }}>*</span>

                                                        </span>
                                                    }
                                                    required={false}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: `${this.context.translate(
                                                                "_TRIP_TYPE_"
                                                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                        },
                                                    ]}
                                                >
                                                    <Select options={this.tripTypeOptions} onChange={this.handleTripTypeChange} />

                                                </Form.Item>
                                                <Form.Item
                                                    className="uploadCompany"
                                                    name="SortStudentBy"
                                                    // initialValue={1}
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_SORT_STUDENT_BY_"
                                                            )}{" "}
                                                            <span style={{ color: "red" }}>*</span>

                                                        </span>
                                                    }
                                                    required={false}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: `${this.context.translate(
                                                                "_SORT_STUDENT_BY_"
                                                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        options={[
                                                            { label: "Assign trip according to vehicle no", value: 'VehicleNo' },
                                                            // { label: 'Assign trip according to special trip', value: 'SpecialTrip' },
                                                            { label: 'Assign trip according to area', value: 'Area' },
                                                        ]}
                                                        onChange={(val) => {

                                                            this.sortTripBy(val);
                                                        }}
                                                    />
                                                </Form.Item>
                                                {this.state.showRouteCombo &&
                                                    <Form.Item
                                                        name="routeId"
                                                        className="uploadCompany"
                                                        label={
                                                            <span>
                                                                {this.context.translate("_ROUTE_")}{" "}
                                                            </span>
                                                        }
                                                        required={false}

                                                    >
                                                        <Select

                                                            // placeholder="Select Asset"
                                                            placeholder={this.context.translate(
                                                                "_SELECT_ROUTE_"
                                                            )}
                                                            style={{ width: "100%" }}
                                                            // mode="multiple"
                                                            showSearch
                                                            fieldNames={{ value: "routeId", label: "routeName" }}
                                                            optionFilterProp="children"
                                                            options={this.studentRouteStore?.routelist || []}
                                                            onChange={async (val) => {
                                                                this.setState({ routeId: val });
                                                                await this.handleRouteChange();
                                                            }}
                                                        />
                                                    </Form.Item>}
                                                {this.state.showVehicleCombo &&
                                                    <Form.Item
                                                        name="vehicleId"
                                                        className="uploadCompany"
                                                        label={
                                                            <span>
                                                                {this.context.translate("_ASSET_")}{" "}
                                                            </span>
                                                        }

                                                    >
                                                        <Select

                                                            // placeholder="Select Asset"
                                                            placeholder={this.context.translate(
                                                                "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                                                            )}
                                                            style={{ width: "100%" }}
                                                            // mode="multiple"
                                                            showSearch
                                                            fieldNames={{ value: "vehicleId", label: "vehicleNo" }}
                                                            optionFilterProp="children"
                                                            options={this.workingHoursStore?.assignAssetList}
                                                            onChange={async (val) => {
                                                                this.setState({ vehicleId: val });
                                                                await this.getRouteDetails();

                                                            }}
                                                        />


                                                    </Form.Item>}
                                                <Form.Item
                                                    name="totalStudent"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_Total_Students_"
                                                            )}{" "}
                                                        </span>
                                                    }
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                {/* {this.state.showSchoolTripCombo &&
                                                    <Form.Item
                                                        name="SchoolTripId"
                                                        className="uploadCompany"
                                                        label={
                                                            <span>
                                                                {this.context.translate("_SCHOOL_TRIP_")}{" "}
                                                            </span>
                                                        }

                                                    >
                                                        <Select
                                                            style={{ width: "100%" }}
                                                            showSearch
                                                            fieldNames={{ value: "SchoolTripId", label: "tripName" }}
                                                            optionFilterProp="children"
                                                            options={this.studentStore?.schoolTripList || []}
                                                        // filterOption={(input, option) => {
                                                        //     return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        // }}

                                                        />
                                                    </Form.Item>
                                                } */}
                                                <Form.Item
                                                    name="area"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate("_AREA_")}{" "}
                                                        </span>
                                                    }

                                                >
                                                    <Input disabled />
                                                    {/* <Select
                                                        disabled
                                                        // placeholder={this.context.translate(
                                                        //     "_SELECT_AREA_"
                                                        // )}
                                                        style={{ width: "100%" }}
                                                        // mode="multiple"
                                                        optionFilterProp="children"
                                                        showSearch
                                                        filterOption={(inputValue, option) => {
                                                            if (option.children) {
                                                                return (
                                                                    option.children
                                                                        .toLowerCase()
                                                                        .indexOf(inputValue.toLowerCase()) >= 0
                                                                );
                                                            }
                                                        }}

                                                    >
                                                        {this.state.arealist.map((val) => {
                                                            return (
                                                                <Option key={val.areaId} value={val.areaId}>
                                                                    {val.areaName}
                                                                </Option>
                                                            );
                                                        })}
                                                    </Select> */}
                                                </Form.Item>
                                                <Form.Item
                                                    className="uploadCompany"
                                                    name="startTime"
                                                    // help={this.state.linkError ? this.state.linkError : null}
                                                    label={
                                                        <span>
                                                            {this.context.translate("_TIME_FROM_")}{" "}
                                                        </span>
                                                    }
                                                    required={false}

                                                >
                                                    <Select
                                                        status={this.state.linkError ? "error" : null}
                                                        onSelect={(val) => this.setState({ fromTime: val })}
                                                        allowClear={true}
                                                    >
                                                        {this.timeOptions()}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    name="endTime"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate("_TIME_TO_")}{" "}
                                                        </span>
                                                    }
                                                >
                                                    <Select
                                                        onSelect={(val) => this.setState({ toTime: val })}
                                                        allowClear={true}
                                                    >
                                                        {this.timeOptions()}
                                                    </Select>
                                                </Form.Item>




                                            </Col>
                                            <Col span={12} className="formColumnClass">
                                                <Form.Item
                                                    name="tripName"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_TRIP_NAME_"
                                                            )}{" "}
                                                            <span style={{ color: "red" }}>*</span>
                                                        </span>
                                                    }
                                                    required={false}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: `${this.context.translate(
                                                                "_TRIP_NAME_"
                                                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                        },
                                                    ]}
                                                >
                                                    <Input />
                                                </Form.Item>

                                                {/* <Form.Item
                                                    name="tripCode"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_TRIP_CODE_"
                                                            )}{" "}
                                                        </span>
                                                    }

                                                >
                                                    <Input disabled />
                                                </Form.Item> */}

                                                <Form.Item
                                                    name="includeStaff"
                                                    label=" "
                                                    valuePropName="checked"
                                                    style={{
                                                        marginBottom: "24px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    <Checkbox onChange={this.handleIncludeStaffChange}>
                                                        {this.context.translate("_INCLUDE_STAFF_")}
                                                    </Checkbox>
                                                </Form.Item>

                                                {this.state.includeStaff && <Form.Item
                                                    name="totalStaff"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_Total_STAFF_"
                                                            )}{" "}
                                                        </span>
                                                    }
                                                >
                                                    <Input disabled />
                                                </Form.Item>}
                                                <Form.Item
                                                    name="tripCloseBufferTime"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate("_TRIP_CLOSURE_BUFFER_TIME_")}{" "}
                                                        </span>
                                                    }

                                                >
                                                    <Select
                                                        allowClear={true}
                                                        options={Array.from({ length: 8 }, (_, i) => {
                                                            const val = (i + 1) * 15;
                                                            return { label: `${val}`, value: val };
                                                        })}

                                                    >

                                                    </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    name="isAutomaticTripClosure"
                                                    label=" "
                                                    valuePropName="checked"
                                                    style={{
                                                        marginBottom: "24px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    <Checkbox onChange={(e) => this.handleTripClosureChange(e.target.checked)}>
                                                        {this.context.translate("_AUTOMATIC_TRIP_CLOSURE_")}
                                                    </Checkbox>
                                                </Form.Item>
                                                {this.state.tripClosure && <Form.Item
                                                    name="tripClosure"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_TRIP_CLOSURE_"
                                                            )}{" "}
                                                        </span>
                                                    }
                                                >

                                                    <Select
                                                        options={[
                                                            { label: "RFID", value: 'RFID' },
                                                            { label: 'Trip Time', value: 'Trip Time' },
                                                            { label: 'Switch', value: 'Switch' },
                                                        ]}
                                                        onSelect={(val) => {
                                                            this.onTripCLosureSelect(val);
                                                        }}
                                                    />
                                                </Form.Item>}
                                                {this.state.showTripCard && <Form.Item
                                                    name="tripCardNo"
                                                    className="uploadCompany"
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_TRIP_START_CLOSE_CARD_NO_"
                                                            )}{" "}
                                                        </span>
                                                    }
                                                >
                                                    <Input />
                                                </Form.Item>}
                                                <Form.Item
                                                    name="dayofweeks"
                                                    label={
                                                        <span>
                                                            {this.context.translate("_WORKING_DAYS_")}{" "}
                                                        </span>
                                                    }

                                                >
                                                    <Select
                                                        mode="multiple"
                                                        maxTagCount="responsive"
                                                        className="select-dropdown"
                                                    >
                                                        <Select.Option value="Sunday">
                                                            {this.context.translate("_SUNDAY_")}
                                                        </Select.Option>
                                                        <Select.Option value="Monday">
                                                            {this.context.translate("_MONDAY_")}
                                                        </Select.Option>
                                                        <Select.Option value="Tuesday">
                                                            {this.context.translate("_TUESDAY_")}
                                                        </Select.Option>
                                                        <Select.Option value="Wednesday">
                                                            {this.context.translate("_WEDNESDAY_")}
                                                        </Select.Option>
                                                        <Select.Option value="Thursday">
                                                            {this.context.translate("_THURSDAY_")}
                                                        </Select.Option>
                                                        <Select.Option value="Friday">
                                                            {this.context.translate("_FRIDAY_")}
                                                        </Select.Option>
                                                        <Select.Option value="Saturday">
                                                            {this.context.translate("_SATURDAY_")}
                                                        </Select.Option>
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item
                                                    className="uploadCompany"
                                                    name="routestartDate"
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_VALID_FROM_"
                                                            )}{" "}
                                                        </span>
                                                    }

                                                    initialValue={dayjs()}
                                                >
                                                    <DatePicker
                                                        style={{ width: "100%", height: "40px" }}
                                                        format={dateFormat}
                                                    // disabled={this.state.disabledField}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    className="uploadCompany"
                                                    name="routestopDate"
                                                    label={
                                                        <span>
                                                            {this.context.translate(
                                                                "_VALID_TO_"
                                                            )}{" "}
                                                        </span>
                                                    }
                                                    required={false}

                                                    initialValue={dayjs()}
                                                >
                                                    <DatePicker
                                                        style={{ width: "100%", height: "40px" }}
                                                        format="YYYY-MM-DD"
                                                    />
                                                </Form.Item>



                                            </Col>
                                        </Row>

                                        <div className="formFooter">
                                            <Button
                                                className="formsCancelButton"
                                                onClick={() => {
                                                    this.closeModal();
                                                }}
                                            >
                                                {this.context.translate(
                                                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                                )}
                                            </Button>
                                            <Button
                                                className="formsCancelButton"
                                                htmlType="submit"
                                            // onClick={() => {
                                            //     this.handleNextClick();
                                            // }}
                                            >
                                                {this.context.translate(
                                                    "_NEXT_"
                                                )}
                                            </Button>
                                            {/* <Button
                                                type="primary"
                                                htmlType="submit"

                                                className="formsSaveButton"
                                            >
                                                {this.context.translate("_SUBMIT_")}
                                            </Button> */}
                                        </div>
                                    </TabPane>

                                    <TabPane
                                        tab={
                                            <span
                                                className={
                                                    this.state.tabErrors["2"] && "validation-failed"
                                                }
                                            >
                                                <Button
                                                    type="text"
                                                    style={{
                                                        background:
                                                            this.state.activeTab === "1"
                                                                ? " rgba(255, 255, 255, 0.30)"
                                                                : "rgb(7, 22, 61)",
                                                        border: "none",
                                                        borderRadius: "0px",
                                                    }}
                                                >
                                                    {this.context.translate(
                                                        "_ASSIGN_BUS_"
                                                    )}
                                                </Button>
                                            </span>
                                        }
                                        key="2"
                                    >

                                        <StudentAssignBus
                                            tripId={this.state.tripId}
                                            companyId={this.state.companyId}
                                            SortStudentBy={this.state.SortStudentBy}
                                            assignedVehicleId={this.state.assignedVehicleId}
                                            tabChange={this.handleTabChange}
                                            closeModal={this.closeModal}

                                        />
                                    </TabPane>
                                    <TabPane
                                        tab={
                                            <span
                                                className={
                                                    this.state.tabErrors["3"] && "validation-failed"
                                                }
                                            >
                                                <Button
                                                    type="text"
                                                    style={{
                                                        background:
                                                            this.state.activeTab === "1"
                                                                ? " rgba(255, 255, 255, 0.30)"
                                                                : "rgb(7, 22, 61)",
                                                        border: "none",
                                                        borderRadius: "0px",
                                                    }}
                                                >
                                                    {this.context.translate(
                                                        "_ASSIGN_STUDENT_"
                                                    )}
                                                </Button>
                                            </span>
                                        }
                                        key="3"
                                    >
                                        <AssignStudent
                                            tripId={this.state.tripId}
                                            companyId={this.state.companyId}
                                            tripType={this.state.tripType}
                                            SortStudentBy={this.state.SortStudentBy}
                                            tabChange={this.handleTabChange}
                                            closeModal={this.closeModal}
                                            response={this.finalSubmit}
                                        />
                                    </TabPane>
                                </Tabs>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        );
    }
}

StudentTripAdd.contextType = StoreContext;
export default observer(withRouter(StudentTripAdd));
